/**
 * Facade
 */
import { config } from 'core/config'

export default config
